import {
  IPriceEntity,
  IPriceEntityWithProvision,
} from '../../entitites/common/price.entity';

export class PriceDto {
  promotion: boolean | undefined;
  premiumBeforeDiscount: number | undefined;
  discountTotal: number | undefined;
  premiumAfterDiscount: number | undefined;
  tax: number | undefined;
  premiumAfterTax: number;

  constructor(entity: IPriceEntity) {
    this.promotion = entity.promotion ?? undefined;
    this.premiumBeforeDiscount = entity.premium_before_discount ?? undefined;
    this.discountTotal = entity.discount_total ?? undefined;
    this.premiumAfterDiscount = entity.premium_after_discount ?? undefined;
    this.tax = entity.tax ?? undefined;
    this.premiumAfterTax = entity.premium_after_tax;
  }
}

export class PriceWithProvisionDto {
  promotion: boolean | undefined;
  premiumBeforeDiscount: number | undefined;
  discountTotal: number | undefined;
  premiumAfterDiscount: number | undefined;
  tax: number | undefined;
  premiumAfterTax: number;
  provision: number;

  constructor(entity: IPriceEntityWithProvision) {
    this.promotion = entity.promotion ?? undefined;
    this.premiumBeforeDiscount = entity.premium_before_discount ?? undefined;
    this.discountTotal = entity.discount_total ?? undefined;
    this.premiumAfterDiscount = entity.premium_after_discount ?? undefined;
    this.tax = entity.tax ?? undefined;
    this.premiumAfterTax = entity.premium_after_tax;
    this.provision = entity.provision;
  }
}
